import React from "react";
import { Link } from "@quintype/components";
import { string } from "prop-types";

import { Twitter, Facebook } from "../../atoms/icons/StoryPageIcons";
import { googleTagEvents } from "../../utils/utils";

import "./socialShareTemplate.m.css";

const SocialShareTemplate = (props) => (
  <span>
    <span
      styleName="icons"
      className="icons"
      onClick={() => googleTagEvents("social-share", `facebook ${props.clickFrom}`, "")}
    >
      <Link aria-label="socal share facebook icons" href={props.fbUrl} target="_blank" rel="noopener noreferrer">
        <Facebook color1={props.color1} color2={props.color2} />
      </Link>
    </span>
    <span
      styleName="icons"
      className="icons"
      onClick={() => googleTagEvents("social-share", `twitter ${props.clickFrom}`, "")}
    >
      <Link aria-label="socal share twitter icons" href={props.twitterUrl} target="_blank" rel="noopener noreferrer">
        <Twitter color1={props.color1} color2={props.color2} />
      </Link>
    </span>
  </span>
);

SocialShareTemplate.propTypes = {
  twitterUrl: string,
  fbUrl: string,
  color1: string,
  color2: string,
  clickFrom: string,
};

export default SocialShareTemplate;
